import { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

/** Displays gallery of images */
const Gallery = ({ images }: { images: [] }) => {
  const [openedImageIndex, setOpenedImageIndex] = useState<number>(null);

  return (
    <div className='flex-gallery'>
      {images.map(
        (image: any, index: number) => {
          return (
            <div key={image.id} onClick={() => setOpenedImageIndex(index)}>
              <img
                loading='lazy'
                src={image.url}
                alt={image.url}
              />

            </div>
          );
        }
      )}

      {openedImageIndex !== null && <Lightbox
        mainSrc={(images[openedImageIndex] as any)?.url}
        prevSrc={
          openedImageIndex > 0
            ? (images[openedImageIndex - 1] as any).url
            : null
        }
        nextSrc={
          (openedImageIndex + 1) < images.length
            ? (images[openedImageIndex + 1] as any).url
            : null
        }
        onCloseRequest={() => { setOpenedImageIndex(null); }}
        onMovePrevRequest={() => {
          setOpenedImageIndex(
            openedImageIndex > 0
              ? openedImageIndex - 1
              : null
          );
        }}
        onMoveNextRequest={() => {
          setOpenedImageIndex(
            (openedImageIndex + 1) < images.length
              ? openedImageIndex + 1
              : null
          );
        }}
      />}
    </div>
  );
};


export default Gallery;
